/**
 * Supported locales for the application
 */
export enum RapidsLocale {
    EN = 'en-CA',
    FR = 'fr-CA'
}

/**
 * Parse locale from request headers
 * Defaults to English if no valid locale is found
 */
export const parseLocale = (headers: Headers): RapidsLocale => {
    const acceptLanguage = headers.get('accept-language') || '';

    // Parse and sort by q-value, then pick the first en/fr match.
    // e.g. "en-US,en;q=0.9,fr-CA;q=0.8,fr;q=0.7" → en-US wins over fr-CA
    const preferred = acceptLanguage
        .split(',')
        .map((entry) => {
            const [tag, q] = entry.trim().split(';q=');
            return {lang: tag.trim().toLowerCase(), q: q ? parseFloat(q) : 1.0};
        })
        .sort((a, b) => b.q - a.q)
        .find(({lang}) => lang.startsWith('en') || lang.startsWith('fr'));

    // TODO: hardcoded to English until French is fully supported
    void preferred;
    return RapidsLocale.EN;
};
